var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.leaderboardAd && _vm.leaderboardAd.length > 0),expression:"leaderboardAd && leaderboardAd.length > 0"}],staticClass:"leaderboard-ad",domProps:{"innerHTML":_vm._s(_vm.leaderboardAd)}})
}
var staticRenderFns = []

export { render, staticRenderFns }